<form [formGroup]="outflowObservationForm">
  <h3
    style="margin: auto 6px; padding: 0px; font-size: 18px; font-weight: 600px"
    mat-dialog-title
  >
    Editar Observación
  </h3>
  <mat-dialog-content
    style="
      height: fit-content;
      max-height: fit-content;
      margin: 0px 6px;
      padding: 0px;
    "
  >
    <div class="w-100">
      <div style="margin: 24px 0">
        <mat-form-field floatLabel="always" class="w-100 miInputTextarea">
          <textarea
            matInput
            id="observation"
            name="observation"
            formControlName="observation"
            rows="7"
            placeholder="Ingresa tu observación"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions style="margin: auto 6px; padding: 0px">
    <div class="button_Footer">
      <button class="buttonSecundary" (click)="closeDialogWithNoData()">
        Cancelar
      </button>
      <button class="buttonPrimary" (click)="updateObservation()">
        <div
          *ngIf="isLoading"
          style="width: 100%"
          class="center-div white-spinner"
          [style.cursor]="isLoading ? 'not-allowed' : 'pointer'"
        >
          Guardando
          <div class="separador"></div>

          <mat-spinner [diameter]="20" class="white-spinner"></mat-spinner>
        </div>
        <div *ngIf="!isLoading">Guardar Cambios</div>
      </button>
    </div>
  </mat-dialog-actions>
</form>
